export default __webpack_public_path__ + "static/media/0216a3ea46c993fee1045b0410f4e0fe.png";